<template>
    <div class="card-shadow-primary  mb-3 card">
        <div class="dropdown-menu-header">
            <div class="dropdown-menu-header-inner bg-plum-plate">
                <div class="menu-header-image" :style="{ backgroundImage: 'url(' + fondo4 + ')' }"></div>
                <div class="menu-header-content">
                    <h4 class="menu-header-title">Menú rapido</h4>
                </div>
            </div>
        </div>
        <div class="grid-menu grid-menu-2col mt-0">
            <div class="no-gutters row">
                <div class="col-sm-6">
                    <router-link :to="{name:'NuevoPedido'}" class="btn-icon-vertical btn-square btn-transition btn btn-outline-success">
                    <i class="fas fa-file-powerpoint btn-icon-wrapper btn-icon-lg mb-3 opacity-9"></i>Nuevo Pedido
                    </router-link>
                </div>
                <div class="col-sm-6">
                    <router-link :to="{name:'ListarArticulos'}" class="btn-icon-vertical btn-square btn-transition btn btn-outline-info">
                    <i class="fas fa-boxes btn-icon-wrapper btn-icon-lg mb-3"></i> Listado de articulos
                    </router-link>
                </div>
                <div class="col-sm-6" v-if="user.tipo == 'Administrador'">
                    <router-link :to="{name:'ListarClientes'}" class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary">
                    <i class="fas fa-users btn-icon-wrapper btn-icon-lg mb-3"></i>Clientes
                    </router-link>
                </div>
                <div class="col-sm-6" v-else>
                    <router-link  :to="{name:'CuentasCorrientes'}" class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary">
                    <i class="fas fa-cash-register btn-icon-wrapper btn-icon-lg mb-3"></i>Cuentas corrientes
                    </router-link>
                </div>
                <div class="col-sm-6" v-if="user.tipo == 'Administrador'">
                    <router-link :to="{name:'ListarPedidosPendientes'}" class="btn-icon-vertical btn-square btn-transition btn btn-outline-danger">
                    <i class="fas fa-history btn-icon-wrapper btn-icon-lg mb-3 opacity-10"></i>Pedidos Pendientes
                    </router-link>
                </div>
                <div class="col-sm-6" v-else>
                    <router-link :to="{name:'HistorialPedidos'}" class="btn-icon-vertical btn-square btn-transition btn btn-outline-focus">
                    <i class="fas fa-history btn-icon-wrapper btn-icon-lg mb-3 opacity-10"></i>Historial de pedidos
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Fondo4 from "@/assets/css/images/dropdown-header/abstract4.jpg";
import { mapGetters } from "vuex";
export default {
  name: "Home",
  data() {
    return {
      fondo4: Fondo4,

    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    })
  }
};
</script>